<template>
    <div :class="['modal', { 'topmost-zindex': isTopMost }]" id="confirmGlobalDialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scv" role="document">
            <div class="modal-content modal-message-content-scv">
                <div class="modal-header modal-header-scv-cmn" style="width: 100%">
                    <div class="modal-header-text-box-scv" style="width: 100%">
                        <span class="modal-header-text-scv">{{title}}</span>
                    </div>
                    <div class="btn-scv-close">
                        <button type="button" class="btn-scv-close message-close" role="button" @click="onBtnCancel()">
                            <div class="icon-font-slategray">
                                <i class="icon-delete"></i>
                            </div>
                        </button>
                    </div>
                </div>
                <div class="modal-body modal-body-scv">
                    <template v-if="IsMultiLine(confirmMessage) === true">
                        <div class="d-flex flex-row">
                            <img :src="GetIcon(messageType)" height="24" style="margin-right: 8px" v-show="!hideIcon" />
                            <span v-html="confirmMessage" style="margin-top: 4px"></span>
                        </div>
                    </template>
                    <template v-else>
                        <div class="d-flex flex-row align-items-center">
                            <img :src="GetIcon(messageType)" height="24" style="margin-right: 8px" v-show="!hideIcon" />
                            <span v-html="confirmMessage"></span>
                        </div>
                    </template>
                </div>
                <div class="modal-footer modal-footer-scv">
                    <div class="d-flex justify-content-center">
                        <div zero-font>
                            <button id="btnOk_confirmGlobalDialog" type="button" class="btn-scv-blue" style="margin-right: 40px;" @click="onBtnOk()">{{btn_ok}}</button>
                            <button id="btnCancel_confirmGlobalDialog" type="button" class="btn-scv-white" @click="onBtnCancel()">{{btn_cancel}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import $ from "jquery";
    import { MessageType } from '@/models/Message/MessageType';
    import alertColor from "@/assets/img/guide_alert_color.svg";
    import questionColor from "@/assets/img/guide_question_color.svg";
    import { BootstrapUtil } from 'lib-vue-v2/util';

    @Options({
        components: {
        },
        emits: [
            'onSelectOK',
            'onSelectCancel'
        ],
        methods: {
            GetIcon(messageType: number) {
                if (messageType === MessageType.Warning) {
                    return alertColor;
                }
                return questionColor;
            },

            IsMultiLine(confirmMessage: string): boolean {
                return (0 <= confirmMessage.indexOf('<br'));
            }
        }
    })

    // 確認ダイアログコンポーネント
    export default class ConfirmGlobalDialog extends Vue {
        private messageType: number = 0;
        private title = "";
        private confirmMessage = "";
        private callbackOK: any = null;
        private callbackCancel: any = null;
        private focusCancel = false;
        private hideIcon = false;
        private btn_ok = "はい";
        private btn_cancel = "いいえ";
        private isOKClick = false;
        private hideResolve: ((value?: void | PromiseLike<void>) => void) | null = null;
        private isTopMost = false;

        public mounted(): void {
            const el = document.getElementById("confirmGlobalDialog");
            if (el != null) {
                el.addEventListener('shown.bs.modal', () => {
                    // いいえにフォーカスをあてる(見た目が変わらないのであまり意味なし)
                    if (this.focusCancel) {
                        $('#btnCancel_confirmGlobalDialog').focus();
                    }
                    else {
                        $('#btnOk_confirmGlobalDialog').focus();
                    }
                });

                el.addEventListener('hidden.bs.modal', () => {
                    if (this.isOKClick){
                        this.$emit('onSelectOK', this.callbackOK);
                    }
                    else {
                        this.$emit('onSelectCancel', this.callbackCancel);
                    }

                    this.messageType = 0;
                    this.title = "";
                    this.confirmMessage = "";
                    this.callbackOK = null;
                    this.callbackCancel = null;
                    this.focusCancel = false;
                    this.hideIcon = false;
                    this.btn_ok = "はい";
                    this.btn_cancel = "いいえ";
                    this.isOKClick = false;

                    if (this.hideResolve) {
                        this.hideResolve();
                        this.hideResolve = null;
                    }
                });

            }

        }

        // OKボタン押下
        public onBtnOk(): void {
            // ※コールバック関数（this.callbackOK）は画面が閉じたときに実行する。
            this.isOKClick = true;

            BootstrapUtil.hideModal('confirmGlobalDialog');
        }

        // Cancelボタン押下
        public onBtnCancel(): void {
            // ※コールバック関数（this.callbackCancel）は画面が閉じたときに実行する。
            this.isOKClick = false;
            
            BootstrapUtil.hideModal('confirmGlobalDialog');
        }

        /*
         * キャンセルボタンにフォーカスするかをセット
         * @param[in] focusCancel : 初期フォーカスがキャンセルならtrue
         */
        public SetCancelFocus(focusCancel: boolean): void {
            this.focusCancel = focusCancel;
        }

        /*
         * アイコンを非表示に設定
         */
        public HideIcon(): void {
            this.hideIcon = true;
        }

        /*
         * アイコンを警告に設定
         */
        public WarningIcon(): void {
            this.messageType = MessageType.Warning;
        }

        /*
         * メッセージの表示
         * @param[in] strHTML : メッセージ内容(HTML)
         * @param[in] callbackOK : OK押下後のコールバック関数
         * @param[in] callbackCancel : キャンセル押下後のコールバック関数
         *              ★Functionクラスで指定すること。コールバック不要ならnull
         * @param[in] okText : OKボタンの文言(undefined : はい)
         * @param[in] cancelText : キャンセルボタンの文言(undefined : いいえ)
         * @param[in] isTopMost : ローディングよりも上に出したい場合に使用。（基本使用禁止。セッションタイムアウトによるログアウト等、強制的に表示したいときのみ使用）
         */
        public Show(strTitle: string, strText: string, callbackOK: any, callbackCancel: any, okText: string | undefined = undefined, cancelText: string | undefined = undefined, isTopMost: boolean = false): void {
            if (0 < this.confirmMessage.length) {
                // 現在表示中
                return;
            }
            this.title = strTitle;
            this.confirmMessage = strText;
            this.callbackOK = callbackOK;
            this.callbackCancel = callbackCancel;
            this.isTopMost = false;

            if (undefined == okText || "" == okText) {
                this.btn_ok = "はい";
            }
            else {
                this.btn_ok = okText;
            }

            if (undefined == cancelText || "" == cancelText) {
                this.btn_cancel = "いいえ";
            }
            else {
                this.btn_cancel = cancelText;
            }

            BootstrapUtil.showModal("confirmGlobalDialog");
        }

        /*
         * メッセージの隠匿
         */
        public Hide(): void {
            BootstrapUtil.hideModal("confirmGlobalDialog");
        }

        /*
         * メッセージの隠匿
         * メッセージ終了時のコールバック処理が完了するまで待機する場合に使用
         */
        public async HideAsync(): Promise<void> {
            if (this.confirmMessage.length === 0) {
                return;
            }

            return await new Promise(resolve => {
                this.hideResolve = resolve;
                this.Hide();
            });
        }
    }

</script>

<style scoped>
    .message-close {
        background-color: #fff;
        border: none;
    }

    .topmost-zindex {
        z-index: 2147483647;
    }
</style>
